import { Component, Output, EventEmitter } from "@angular/core";
import * as loginStrings from "../stringFiles/newLogin.json";
import { NewLoginWithDomainServices } from "./new-login-with-domain.service";
import { firstValueFrom } from "rxjs";
import { commonFunctionService } from "../utils/commonFunctions";
import { TranslateService } from "@ngx-translate/core";
import { BrandService } from "../brand/brand.service";

declare var $: any;
declare var customToastr: any;
@Component({
  selector: "app-new-login-with-domain",
  templateUrl: "./new-login-with-domain.component.html",
  styleUrl: "./new-login-with-domain.component.css",
  providers: [NewLoginWithDomainServices],
})
export class NewLoginWithDomainComponent {
  @Output() loginWithEmailIdClicked: EventEmitter<void> =
    new EventEmitter<void>();

  onLoginWithEmailIdClicked(): void {
    this.loginWithEmailIdClicked.emit();
  }

  loginStrings: any = loginStrings;
  loginDebounceTimer: any;
  schoolUrl: string;
  schoolUrlLength: number = 0;
  isUrlIsValid: boolean = false;
  userEmail: string;
  password: string;
  emailAddressLength: any = 0;
  isEmailAddressValid: boolean = false;
  loader: boolean = false;
  isGoBack : boolean = false;
  errorMessage = {
    url: "",
    userEmail: "",
  };
  brand = this.brandService.brand;

  constructor(private commonFunction: commonFunctionService,private newLoginWithDomainServices: NewLoginWithDomainServices, private translate: TranslateService, private brandService: BrandService) {
    this.initScript();
  }

  initScript() {
    $(".after").empty();
    $("#device-breakpoints").remove();
    $(".after").append(
      "<script>function customToastr(message,type){toastr.options.hideDuration = 0;toastr.clear();" +
      "toastr.options.closeButton = true;toastr.options.progressBar = false;toastr.options.debug = false;" +
      "toastr.options.positionClass = 'toast-top-right';toastr.options.showDuration = 330;toastr.options.hideDuration = 330;" +
      "toastr.options.timeOut = 5000;toastr.options.extendedTimeOut = 1000;toastr.options.showEasing = 'swing';" +
      "toastr.options.hideEasing = 'swing';toastr.options.showMethod = 'slideDown';toastr.options.hideMethod = 'slideUp';" +
      "toastr[type](message, '');return 0;} </" +
      "script>"
    );
  }

  //School URL debouncing function
  handleDebounceUrl(value: string): void {
    clearTimeout(this.loginDebounceTimer);
    this.loginDebounceTimer = setTimeout(() => {
      this.triggerUrlValidator(value);
    }, 800);
  }

  //School URL Validation function
  triggerUrlValidator(input: any) {
    const url = input.value.trim();
    this.schoolUrl = url;
    this.schoolUrlLength = url.length;
    if (this.schoolUrlLength < 2 && this.schoolUrlLength > 0) {
      this.errorMessage.url = this.loginStrings.errorMessageForUrl;
      this.isUrlIsValid = false;
    } else {
      this.errorMessage.url = "";
      this.isUrlIsValid = true;
    }
  }

  //Navigating to the register
  openRegisterLink() {
    const protocol = window.location.protocol;
    const hostName = window.location.hostname;
    const urlHost = hostName.split(".")[1];
    if (urlHost === this.loginStrings.localhost) {
      window.location.href = this.loginStrings.localHostLogin;
    } else {
      const domainSuffix = this.brand.domainSuffix || hostName.split(".").slice(1).join(".");
      window.location.href = protocol + "//registration." + domainSuffix;
    }
  }
  handleContinue() {
    this.verifySchoolDomainDetails();
  }

  //Email address debouncing function
  handleDebounceEmail(value: string): void {
    clearTimeout(this.loginDebounceTimer);
    this.loginDebounceTimer = setTimeout(() => {
      this.triggerLoginEmailError(value);
    }, 800);
  }

  //Email address validation function
  triggerLoginEmailError(input: any) {
    const emailAddress = input.value.trim();
    this.emailAddressLength = emailAddress.length;
    this.userEmail = emailAddress;
    if (this.emailAddressLength < 2 && this.emailAddressLength > 0) {
      this.errorMessage.userEmail =
        this.loginStrings.errorMessageForUserOrEmailAddress;
      this.isEmailAddressValid = false;
    } else {
      this.errorMessage.userEmail = "";
      this.isEmailAddressValid = true;
    }
  }

  // API call for domain exist or not
  async verifySchoolDomainDetails() {
    try {
      this.loader = true;
      const domainSuffix = this.brand.domainSuffix || window.location.hostname.split(".").slice(1).join(".");
      const body = {
        domainName: this.schoolUrl,
        lang: "en",
        partnerDomain: domainSuffix,
      };
      const response = await firstValueFrom(
        this.newLoginWithDomainServices.verifySchoolDomainDetailsApi(body)
      );
      const responseDetails = response as any;
      if (responseDetails.status) {
        if (responseDetails.body) {
          const subDomain = this.schoolUrl + ".";
          const protocol = window.location.protocol + "//";
          const hostName = window.location.hostname;
          const urlHost = hostName.split(".")[1];
          const domainSuffix = this.brand.domainSuffix || hostName.split(".").slice(1).join(".");
          let redirectUrl = "";
          if (urlHost === this.loginStrings.localhost) {
            redirectUrl = protocol + subDomain + urlHost + this.loginStrings.localHostPortPath;
          } else {
            redirectUrl = protocol + subDomain + domainSuffix + this.loginStrings.bluewingsPortPathLogin;
          }
          const lang = localStorage.getItem('lang');
          this.commonFunction.setCookie('lang', lang, 1);
          
          window.location.href = redirectUrl;
          customToastr(responseDetails.body.message, this.loginStrings.success);
          this.schoolUrl = "";
          this.schoolUrlLength = 0;
        } else {
          customToastr(responseDetails.message, this.loginStrings.error);
        }

      } else {
        customToastr(responseDetails.message, this.loginStrings.error);
      }
      this.loader = false;
    } catch (error) {
      const errorMessageTranslation = await firstValueFrom(this.translate.get('errorMessage')); 
      customToastr(
        error
          ? error.error
            ? error.error.message
            : errorMessageTranslation
          : errorMessageTranslation,
        this.loginStrings.error
      );
      this.loader = false;
      return;
    }
  }
}
